import { css } from 'styled-components'

import cond from 'ramda/src/cond'
import T from 'ramda/src/T'
import equals from 'ramda/src/equals'

/**
 * @typedef {import('../model').ValueState} ValueState
 */

// prettier-ignore
/**
 * @param {{ value: ValueState }} props
 * @returns {import('styled-components').InterpolationValue[]}
 */
export const valueStyles = ({ value }) => cond([
  [equals(''), () => css`
    color: #ddd;
    background-color: currentColor;
    border-right-color: currentColor;

    pointer-events: none;
    cursor: default;
  `],
  [equals('-'), () => css`
    display: flex;
    align-items: center;
    justify-content: center;

    &::after {
      content: '-';
      color: #333333;
      font-family: 'Gotham' !important;
      font-size: 14px;
    }
  `],
  [T, n => {
    const baseStyles = css`
    position: relative;

    &::after {
      content: '${(n || 0).toFixed(2)}%';
      width: 66px;
      height: 25px;
      padding: 2px 0 0 2px;

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      display: flex;
      align-items: center;
      justify-content: center;

      border-radius: 20px;

      color: #333333;
      font-family: 'Gotham' !important;
      font-size: 14px;
    }
  `

    if (n > 30.0) {
      return css`
        ${baseStyles}
        &::after {
          background-color: #8fd98f;
        }
      `
    }
    if (n < 20.0) {
      return css`
        ${baseStyles}
        &::after {
          background-color: #ecadad;
        }
      `
    }

    return baseStyles
  }],
])(value)



// WEBPACK FOOTER //
// ./src/pages/report/project-profit-sheet/components/modifiers.js